import type { IconSvgObject } from './types';

const SoftDrink01Icon: IconSvgObject = [
  ["path", { d: "M12 7.00012L12 4.00017C12 2.89563 12.8954 2.0002 13.9999 2.00016L17.5 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 7L7.3199 20.199C7.42214 21.2214 8.28247 22 9.30998 22H14.69C15.7175 22 16.5779 21.2214 16.6801 20.199L18 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 7L19 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 12H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M7 16H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default SoftDrink01Icon;
